import i18n from "@/i18n";
import {
  searchSignatureTemplate,
  getSignatureTemplate,
  createSignatureTemplate,
  updateSignatureTemplate,
  deleteSignatureTemplate,
} from "@/store/services/configuration/signatureTemplateService";
import { SignatureTemplateState } from "@/types";
import Notify from 'quasar/src/plugins/Notify.js';;
import { Module } from "vuex";

const signatureTemplateModule: Module<SignatureTemplateState, unknown> = {
  namespaced: true,
  state: {
    signatureTemplateList: [],
    selectedSignatureTemplate: {},
    isLoading: false,
  },
  getters: {
    getSignatureTemplateList: (state): any[] => {
      return state.signatureTemplateList;
    },
    getSelectedSignatureTemplate: (state): any => {
      return state.selectedSignatureTemplate;
    },
    getIsLoading: (state): boolean => {
      return state.isLoading;
    },
  },
  actions: {
    searchSignatureTemplate({ commit }, payload) {
      const { filter, offset, limit, callback } = payload;
      searchSignatureTemplate(filter, offset, limit)
        .then((res) => {
          callback(res);
        })
        .catch((e) => console.error(e));
    },
    getSignatureTemplate({ commit }, payload) {
      const { resourceUid, callback } = payload;
      getSignatureTemplate(resourceUid)
        .then((res: any) => {
          commit("setSelectedSignatureTemplate", res.data);
          if (callback) callback(res.data);
        })
        .catch((e: any) => {
          console.error(e);
          Notify.create({
            message: i18n.global.t("main.dialog.loadError", { entity: resourceUid }),
            color: "negative",
          });
        });
    },
    createSignatureTemplate({ commit }, payload) {
      const { signatureTemplate, callback } = payload;
      createSignatureTemplate(signatureTemplate)
        .then((res: any) => {
          Notify.create({
            message: i18n.global.t("main.dialog.success", { entity: res.data?.resourceUid }),
            color: "positive",
          });
          if (callback) callback(res);
        })
        .catch((e: any) => console.error(e));
    },
    updateSignatureTemplate({ commit }, payload) {
      const { resourceUid, signatureTemplate, callback } = payload;
      updateSignatureTemplate(resourceUid, signatureTemplate)
        .then((res: any) => {
          Notify.create({
            message: i18n.global.t("main.dialog.success", { entity: res.data?.resourceUid }),
            color: "positive",
          });
          if (callback) callback(res);
        })
        .catch((e: any) => console.error(e));
    },
    deleteSignatureTemplate({ commit }, payload) {
      const { resourceUid } = payload;
      deleteSignatureTemplate(resourceUid)
        .then((res: any) => {
          Notify.create({
            message: i18n.global.t("order.messages.deleteSuccess"),
            color: "positive",
          });
        })
        .catch((err: any) => {
          console.error(err);
          Notify.create({
            message: err,
            color: "negative",
          });
        });
    },
    cleanState({ commit }) {
      commit("setInitial");
    },
  },
  mutations: {
    setSignatureTemplateList(state, payload) {
      state.signatureTemplateList = payload;
    },
    setSelectedSignatureTemplate(state, payload) {
      state.selectedSignatureTemplate = payload;
    },
    setIsLoading(state, payload) {
      state.isLoading = payload;
    },
    setInitial(state) {
      state.signatureTemplateList = [];
      state.selectedSignatureTemplate = {};
      state.isLoading = false;
    },
  },
};

export default signatureTemplateModule;
